import { Flex, TextStyled, theme } from '../component-library';
import { DefaultButton } from '../components';
import styled from '@emotion/styled';
import { useAppointment } from '../context/appointmentContext';
import { client } from '../helpers/api-client';
import { useEffect, useState, useCallback } from 'react';
import { todayString } from '../helpers/functions';

const TextArea = styled.textarea`
  width: 100%;
`;

const Notes = () => {
  const {
    appointment: { currentAppointment },
  } = useAppointment();
  const [localNotes, setLocalNotes] = useState('');
  const [notesUpdated, setNotesUpdated] = useState(null);

  useEffect(() => {
    const getServerNotes = async () => {
      const { notes } = await client(`api/appointments/${currentAppointment.id}/`);
      setLocalNotes(notes || '');
    };

    getServerNotes();
  }, [currentAppointment]);

  const saveNotes = async () => {
    client(
      `api/appointments/${currentAppointment.id}/`,
      {
        body: {
          notes: localNotes,
        },
      },
      'PATCH',
    ).then(
      (data) => {
        setNotesUpdated(todayString());
      },
      (error) => {
        console.error('Error: ', error);
      },
    );
  };

  const handleChange = (event) => {
    setLocalNotes(event.target.value);
  };

  return (
    <Flex mt='3' mb='3' width='100%'>
      <Flex flexDirection='column' borderRadius='12px' overflow='hidden' width='100%' boxShadow='0px 11px 22px #B9D5D5'>
        <Flex overflow='auto' justifyContent='center' alignItems='center' bg='white' flexDirection='column' height='100%'>
          <TextStyled p='5px' backgroundColor={theme.colors.primary} color='white' textAlign='center' width='100%'>
            Notes:
          </TextStyled>
          <Flex width='90%' justifyContent='center' alignItems='center' pt='5px'>
            <TextArea rows='5' cols='50' style={{ border: '1px solid #c1c1c1' }} value={localNotes} onChange={handleChange} />
          </Flex>
          {notesUpdated ? <Flex mt='10px'>Latest notes update: {notesUpdated}</Flex> : ''}
          <Flex mb='10px'>
            <DefaultButton
              text='save'
              uppercase
              onClick={() => {
                saveNotes();
              }}
              mt='10px'
            />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Notes;
